import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { msalConfig } from "../../configs/MSAL.config";
import { decodeToken } from "react-jwt";
import { useLocation, useHistory } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";

const AuthB2C = () => {
  const { instance, inProgress } = useMsal();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    instance.initialize();
    const SSORequest = async () => {
      try {
        await instance.loginRedirect({
          authority: process.env.REACT_APP_MSAL_AUTHORITY,
          scopes: msalConfig.auth.scopes,
          redirectStartPage: "/issue-request",
        });
      } catch (error) {
        console.error(error);
      }
      // const params = new URLSearchParams(location.search);
      // const token = params.get("idToken");

      // try {
      //   const decodedToken = decodeToken(token);
      //   const silentRequest = {
      //     scopes: msalConfig.auth.scopes,
      //     loginHint: decodedToken.email,
      //   };
      //   instance
      //     .ssoSilent(silentRequest)
      //     .then((res) => {
      //       console.log(res, "res");
      //       history.push("/dashboard");
      //     })
      //     .catch((err) => {
      //       history.push("/");
      //     });
      // } catch (err) {
      //   console.log(err, "err");
      //   history.push("/");
      // }
    };

    if (inProgress === InteractionStatus.None) {
      SSORequest();
    }
  }, [history, inProgress, instance, location.search]);
  return <p className="text-center">...Loading</p>;
};

export default AuthB2C;
